import type { Analytics } from "@/types";
import React from "react";

import { getDuneEmbeddedLink } from "@/utils";

interface ProtocolAnalyticsProps {
  analytics: Analytics[];
}

export default function ProtocolAnalytics({ analytics }: ProtocolAnalyticsProps) {
  return (
    analytics.length > 0 && (
      <div className="mx-6 mb-7 flex flex-col">
        {analytics.map(
          (link, index: number) =>
            [0, 1].includes(index) && (
              <iframe
                src={getDuneEmbeddedLink(link.chart_url)}
                key={`dune_links_${index}`}
                className="h-[462px] w-full min-[393px]:h-[586px] min-[430px]:h-[650px] md:h-[160px] min-[834px]:h-[182px] lg:h-[231px]
                    xl:h-[297px] min-[1440px]:h-[338px] min-[1512px]:h-[356px] min-[1728px]:h-[403px]"
                title="Real Yield Daily Deposit volume"
              />
            )
        )}
        <div className="flex flex-col justify-between md:grid md:grid-cols-2">
          {analytics.map(
            (link, index: number) =>
              index > 1 && (
                <iframe
                  src={getDuneEmbeddedLink(link.chart_url)}
                  key={`dune_links_${index}`}
                  className="h-[225px] w-full min-[393px]:h-[286px] min-[430px]:h-[316px] md:h-[78px] min-[834px]:h-[90px] lg:h-[114px]
                      xl:h-[146px] min-[1440px]:h-[167px] min-[1512px]:h-[176px] min-[1728px]:h-[201px]"
                  title="Real Yield Median Calculations"
                />
              )
          )}
        </div>
      </div>
    )
  );
}
